module.exports = __webpack_public_path__ + "img/next.6ab344d9.png";